// extracted by mini-css-extract-plugin
export default {"box":"RadioMenu_box__LByEG","btnBox":"RadioMenu_btnBox__D3MpF","btn":"RadioMenu_btn__fou8t","btnAct":"RadioMenu_btnAct__0leHn"};